import { globalAxios } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    report_list: []
  },
  mutations: {
    resetState(state) {
      state.report_list = [];
    },
    getReportList(state, data) {
      state.report_list = data;
    }
  },
  actions: {
    async getReportList({ commit, rootState, dispatch }, data_search) {
      let url =
        rootState.api_urls.fetchReportMessenger_getReportList +
        data_search.status_id +
        "/" +
        data_search.date_start +
        "/" +
        data_search.date_end;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("getReportList", res);
      }
    },
     fetchOrderReceiptByDistrict({ rootState, dispatch, commit }, data_search) {
      let url =
        `/api/v1/${
          rootState.backOffice.province
        }/search_by_district/report_messenger/order_status/datetime_start/datetime_end/` +
        data_search.status_id +
        "/" +
        data_search.date_start +
        "/" +
        data_search.date_end;
        
      let payload = {
        district: data_search.district_id,
      };
      return globalAxios
        .post(url, payload)
        .then((res) => {
          commit("getReportList", res);
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
  },
  getters: {}
};
